/* eslint-disable no-restricted-globals */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Textarea } from '@cbrebuild/blocks';
import useFormState, { EVENT_VALUE_TYPES } from '../../../hooks/useFormState';
import FormGroup from '../../../nucleus/form-group/form-group';
import { updateCompData } from '../../../redux/actions/voucher/comp-data-actions';
import Select from '../../../nucleus/select/select';
import NumberInput from '../../../nucleus/inputs/NumberInput';
import FileUploadAccordian, { getVoucherAccordionStorageKey } from '../../file-upload/file-upload-accordian';

const typeOverrides = {
  office_area: EVENT_VALUE_TYPES.FLOAT,
  office_rent_amount_per_sqft: EVENT_VALUE_TYPES.FLOAT,
  warehouse_rent_amount_per_sqft: EVENT_VALUE_TYPES.FLOAT,
  clear_height: EVENT_VALUE_TYPES.FLOAT,
  power_amps: EVENT_VALUE_TYPES.FLOAT,
  power_volts: EVENT_VALUE_TYPES.FLOAT,
};

const yesNoOptions = [
  { display_name: 'Yes', value: 'Yes' },
  { display_name: 'No', value: 'No' },
];

const railServicedOptions = [
  { display_name: 'Yes', value: 'Yes' },
  { display_name: 'No', value: 'No' },
];

const LeaseCompExtraFields = () => {
  const { compData, dealId } = useSelector(state => ({
    compData: state.compData,
    dealId: state.deal.deal?.id,
    voucher: state.voucher.voucher,
  }));
  const dispatch = useDispatch();

  const {
    general_comments,
    office_area,
    office_rent_amount_per_sqft,
    warehouse_rent_amount_per_sqft,
    clear_height,
    power_amps,
    power_volts,
    gl_door_count,
    dh_door_count,
    truckwell_count,
    cross_dock_count,
    rail_serviced,
    onStateChange,
    onStateChanged,
  } = useFormState({
    general_comments: compData?.general_comments,
    office_area: compData?.office_area,
    office_rent_amount_per_sqft: compData?.office_rent_amount_per_sqft,
    warehouse_rent_amount_per_sqft: compData?.warehouse_rent_amount_per_sqft,
    clear_height: compData?.clear_height,
    power_amps: compData?.power_amps,
    power_volts: compData?.power_volts,
    gl_door_count: compData?.gl_door_count,
    dh_door_count: compData?.dh_door_count,
    truckwell_count: compData?.truckwell_count,
    cross_dock_count: compData?.cross_dock_count,
    rail_serviced: compData?.rail_serviced,
  }, changes => dispatch(updateCompData(compData.id, changes)), typeOverrides);

  return (
    <>
      {/* Industrial Leases */}
      <FileUploadAccordian accordianTitle="Industrial Leases" storageKey={getVoucherAccordionStorageKey(dealId, 'leaseComp', 'industrialLeases')}>
        <div className="field-group field-group--row">
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Office Area (SqFt)" size="large">
              <NumberInput name="office_area" value={office_area.value} precision={0} integerPrecision={11} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Office Rent ($/SqFt)" size="large">
              <NumberInput
                name="office_rent_amount_per_sqft"
                value={office_rent_amount_per_sqft.value}
                precision={2}
                integerPrecision={11}
                onChange={onStateChange}
                onBlur={onStateChanged}
              />
            </FormGroup>
          </div>
        </div>
        <div className="field-group field-group--row">
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Warehouse Rent ($/SqFt)" size="large">
              <NumberInput
                name="warehouse_rent_amount_per_sqft"
                value={warehouse_rent_amount_per_sqft.value}
                precision={2}
                integerPrecision={11}
                onChange={onStateChange}
                onBlur={onStateChanged}
              />
            </FormGroup>
          </div>
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Clear Height (Feet)" size="large">
              <NumberInput name="clear_height" value={clear_height.value} precision={4} integerPrecision={11} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
        </div>
        <div className="field-group field-group--row">
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Power (Amps)" size="large">
              <NumberInput name="power_amps" value={power_amps.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Power (Volts)" size="large">
              <NumberInput name="power_volts" value={power_volts.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
        </div>
        <div className="field-group field-group--row">
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="GL Door Count" size="large">
              <NumberInput name="gl_door_count" value={gl_door_count.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="DH Door Count" size="large">
              <NumberInput name="dh_door_count" value={dh_door_count.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
        </div>
        <div className="field-group field-group--row">
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Truckwell Count" size="large">
              <NumberInput name="truckwell_count" value={truckwell_count.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
          <div className="form-row-with-labels-and-hints">
            <FormGroup hasError={false} label="Cross Dock Count" size="large">
              <NumberInput name="cross_dock_count" value={cross_dock_count.value} precision={0} integerPrecision={10} onChange={onStateChange} onBlur={onStateChanged} />
            </FormGroup>
          </div>
        </div>
        <div className="form-row-with-labels-and-hints">
          <FormGroup hasError={false} label="Rail Serviced" size="large">
            <Select
              defaultOption={railServicedOptions.find(o => o.value === rail_serviced.value)}
              onChange={({ value }) => onStateChanged({
                target: { value, name: 'rail_serviced', type: 'text' },
              })}
              options={yesNoOptions}
            />
          </FormGroup>
        </div>
      </FileUploadAccordian>

      {/* General Comments */}
      <FileUploadAccordian accordianTitle="General Comments" storageKey={getVoucherAccordionStorageKey(dealId, 'leaseComp', 'generalComments')}>
        <FormGroup hasError={false} label="" size="large">
          <Textarea
            id="lease-comp-general-comments"
            name="general_comments"
            rows={{ min: 4, max: 130 }}
            onChange={onStateChange}
            onBlur={onStateChanged}
            value={general_comments.value || ''}
          />
        </FormGroup>
      </FileUploadAccordian>
    </>
  );
};

export default LeaseCompExtraFields;
